// extracted by mini-css-extract-plugin
export default {"title":"ptitle_title__ar8gR"};